<template>
    <div class="pop" v-show="show"  @click.stop='_=>{}'>
        <div class="box">
            <div class="title">
                <span @click="show = false" class="closeBtn"></span>
            </div>
            <div class="wrap" style="border:0">
                <p>请填写《概率的朋友》邮寄地址，邮费由文华承担。</p>
                <div class="line nessasery">
                    <label>收件人</label>
                    <input type="text" v-model="name">
                </div>
                <div class="line nessasery">
                    <label>手机号</label>
                    <input type="text" v-model="phone">
                </div>

                <div class="line nessasery">
                    <label>所在地区</label>
                    <select v-model='provinceId' @change="changeQueryCity">
                        <option  :value="item" v-for='(item,index) in province' :key='index'>
                            {{item.regioN_NAME}}</option>
                    </select>
                    <select v-model='cityId' style='margin-left:18px;' >
                        <option :value="item" v-for='(item,index) in city' :key='index'>
                            {{item.regioN_NAME}}</option>
                    </select>
                </div>
                <div class="line nessasery">
                    <label>详细地址</label>
                    <textarea type="text" v-model="address"></textarea>
                </div>
                <p style="height:16px;text-align:center;color:red;margin-bottom: 12px;margin-left: 25px;">{{msg}}</p>
                <button class="roger" @click="sub">{{status ? '确定' : '提交'}}</button>
            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    // @ is an alias to /src

    export default {
        name: 'alert',
        data: () => ({
            show: true,
            province: [{regioN_ID: null,regioN_NAME: "省份"}],
            provinceId: {regioN_ID: null,regioN_NAME: "省份"},
            city: [{regioN_ID: null,regioN_NAME: "城市"}],
            cityId: {regioN_ID: null,regioN_NAME: "城市"},
            name: '',
            phone: '',
            msg: '',
            address: '',
            status: null
        }),
        props: {
            confirmCall: {
                default: () => {},
                type: Function
            },
            orderInfo:{
                default: () => {},
                type: Object
            },
            orderId:{
                default: '',
                type: String
            },
            closePop:{
                default: () => {},
                type: Function
            }
        },
        methods: {
            close() {
                this.show = false
            },
            changeQueryCity(city) {
                let vm = this;

                if(vm.provinceId.regioN_ID==null||vm.provinceId.regioN_ID==undefined){
                    return
                }
                
                axios({
                    url: '/api/Order/GetProv?type=2&id=' + vm.provinceId.regioN_ID,
                    method: 'get'
                }).then(res => {
                    vm.city = [{regioN_ID: null,regioN_NAME: "城市"}].concat(res.data)
                    vm.cityId = vm.city[0]
                        
                    if(city=='init'){
                        let index = vm.city.findIndex(item=>item.regioN_NAME== vm.orderInfo.city)
                        vm.cityId = vm.city[index]
                    }

                })
            },
            sub () {
                let vm = this;

                if(vm.status) {
                    vm.close()
                    vm.closePop()
                    return
                }
                
                if (vm.name == '') {
                    vm.msg = '收件人为必填项'
                    return
                }
                if (/^\d+$/g.test(vm.name)) {
                    vm.msg = '收件人不能为纯数字'
                    return;
                }
                if (vm.phone == '') {
                    vm.msg = '手机号为必填项'
                    return;
                }
               
                if (!(/^[1][0-9]{10}$/.test(vm.phone))) {
                    vm.msg = '手机号码格式不正确'
                    return;
                }

                if (vm.provinceId.regioN_NAME == '省份' ) {
                    vm.msg = '请选择省份'
                    return;
                }
                if (vm.cityId.regioN_NAME == '城市' ) {
                    vm.msg = '请选择城市'
                    return;
                }
                if (vm.address=='') {
                    vm.msg = '详细地址不能为空'
                    return;
                }
                axios({
                    url: '/api/Order/CreateBooks',
                    method: 'post',
                    data: {
                        "phonenum":  vm.phone,//赠书手机号
                        "user_accept":  vm.name,//赠书收件人
                        "phonenum_accept": vm.orderInfo.phone,//订单手机号
                        "provname": vm.provinceId.regioN_NAME,
                        "cityname": vm.cityId.regioN_NAME,
                        "address": vm.address,
                        "orderid": vm.orderId,
                        "idcard": vm.orderInfo.idcard
                    }
                }).then(res => {
                    // this.close()
                    vm.status = res.data.success
                    vm.msg = res.data.message

                    if(res.data.success){
                        vm.close()
                        vm.closePop()
                        this.$market.alert({
                            content: res.data.message
                        });
                    }
                })
            }
        },
        components: {

        },
        watch: {
            // provinceId (val) {
            //     axios({
            //         url: '/api/Order/GetProv?type=2&id=' + val.regioN_ID,
            //         method: 'get'
            //     }).then(res => {
            //         this.city = [{regioN_ID: null,regioN_NAME: "城市"}].concat(res.data)
            //         this.cityId = this.orderInfo.cityId
            //     })
            // },
           
        },
        mounted() {
            axios({
                url: '/api/Order/GetProv?type=1',
                method: 'get'
            }).then(res => {
                this.province = [{regioN_ID: null,regioN_NAME: "省份"}].concat(res.data)
                
                if( this.orderInfo.prov!=''&&this.orderInfo.prov!=undefined){
                    let index = this.province.findIndex(item=>item.regioN_NAME==this.orderInfo.prov)
                    this.provinceId = this.province[index]
                    this.changeQueryCity('init')
                }else{
                    this.provinceId = this.province[0]
                }
            })

            setTimeout(() => {
                console.log( this.orderInfo)
                this.phone = this.orderInfo.phone
                this.name = this.orderInfo.username
            }, 0);

        }
    }
</script>

<style scoped>
    .pop {
        position: fixed;
        z-index: 2000;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .2);
    }

    .line {
        width: 380px;
        margin-left: 15px;
        margin-bottom: 10px;
    }

    .line label {
        width: 80px;
        display: inline-block;
    }

    .line input {
        width: 260px;
        height: 26px;
        outline: none;
        border: 1px solid #999;
        border-radius: 3px;
        color: #545454;
    }

    .line select {
        width: 124px;
        height: 30px;
        outline: none;
        border: 1px solid #999;
        border-radius: 3px;
        color: #545454;
    }

    .box {
        width: 470px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border-radius: 10px;
        overflow: hidden;
        background: white;
    }

    .title {
        height: 34px;
        background: white;
        color: #fafafa;
        font-size: 15px;
        line-height: 34px;
        padding-left: 11px;
    }

    .wrap {
        background: #fff;
        border: 1px solid #8b8b8b;
        border-top: 0;
        padding: 0 20px 20px;
        color: #7c7c7c;
        font-weight: bolder;
        font-size: 14px;
    }

    .wrap h2 {
        font-size: 18px;
        padding: 0;
        margin: 0;
    }

    .wrap p {
        padding: 0;
        margin-left: 15px;
        /* font-weight: normal; */
        margin-bottom: 20px;
        width: 380px;
    }

    .roger {
        color: #fff;
        font-weight: bolder;
        /* background: rgb(73, 132, 212); */
        background: #f2676c;
        padding: 5px 28px;
        cursor: pointer;
        display: block;
        width: 85px;
        zoom: 1;
        margin: 0 auto;
        border: 0;
        /* margin-top: 25px; */
        outline: 0;
        border-radius: 3px;
    }
    .closeBtn {
        width: 20px;
        height: 20px;
        position: absolute;
        right: 15px;
        top: 15px;
        background: url(../assets/image/book_close_btn.svg) no-repeat center;
        background-size: 100%;
        cursor: pointer;
    }

    textarea {
        /* 去掉边框、轮廓、默认内边距、缩放 */
        /* border: none; */
        outline: none;
        padding: 0;
        resize: none; /* 禁止右下角拖拽缩放 */
        background: transparent;
        font-family: inherit; /* 继承父级字体，去掉默认系统字体 */
        font-size: inherit;
        width: 266px;
        border-radius: 3px;
        padding: 5px;
        box-sizing: border-box;
        height: 80px;
        vertical-align: top;
        color: #545454;
        border-color: #a09c9c;
    }
</style>